module.exports = __webpack_public_path__ + "img/bottom-2.83d2276d.jpg";